import classNames from "classnames";
import React, { CSSProperties, FC } from "react";

import {
  AVATAR_COLOR_VARIANTS,
  AVATAR_SIZE_VARIANTS,
} from "./Avatar.constants";
import { AvatarColor, AvatarProps } from "./Avatar.types";

const isDefaultAvatarColor = (color: string): color is AvatarColor => {
  return color in AVATAR_COLOR_VARIANTS;
};

const getAvatarLabel = (label?: string, fullName?: string): string => {
  const trimmedLabel = label?.trim();

  if (trimmedLabel) {
    return trimmedLabel.slice(0, 2).toUpperCase();
  }

  const trimmedFullName = fullName?.trim();

  if (!trimmedFullName) {
    return "N/A";
  }

  const nameParts = trimmedFullName.split(/\s+/);

  if (nameParts.length === 1) {
    return nameParts[0].slice(0, 2).toUpperCase();
  }

  return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
};

export const Avatar: FC<AvatarProps> = ({
  label,
  fullName,
  avatarClassNames,
  size = "md",
  color,
}) => {
  const avatarColor = color || "primary";
  const isDefaultColor = isDefaultAvatarColor(avatarColor);

  const customColorStyle: CSSProperties | undefined = !isDefaultColor
    ? { backgroundColor: avatarColor }
    : undefined;

  return (
    <div
      title={fullName}
      aria-label={fullName}
      style={customColorStyle}
      className={classNames(
        "flex items-center justify-center rounded-full font-medium text-white",
        AVATAR_SIZE_VARIANTS[size],
        isDefaultColor && AVATAR_COLOR_VARIANTS[avatarColor],
        avatarClassNames,
      )}>
      {getAvatarLabel(label, fullName)}
    </div>
  );
};
